import {useEffect, useState} from "react";
import logo from "./../assets/images/logo.png"
import { useAppSelector, useAppDispatch } from '../hooks/hook'
import {getDepartments} from "../store/thunks/departmentThunk";
import Select from "react-dropdown-select";
import {RootState} from "../store/store";
import {ModalAccount} from "../compoments/ModalAccount";
import {onLogout} from "../store/thunks/authTrunk";
import {useNavigate} from "react-router-dom";
import {setShowModal, setShowRegister} from "../store/slices/authSlice";
import {ShowNotification} from "../compoments/ShowNotification";
import {ModalRegister} from "../compoments/ModalRegister";
export const HeaderAppointment = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate();
    const {status, showModal, session, showRegister} = useAppSelector((state: RootState) => state.auth);

    const [showProfile, setShowProfile] = useState(false);
    const callback = () => {
      if (showProfile) {
          setShowProfile(!showProfile);
      }
    }
    useEffect(() => {
        const handleClick = () => {
            callback();
        };
        document.addEventListener('click', handleClick);
        return () => {
        document.removeEventListener('click', handleClick);
        };
    }, []);

    useEffect(() => {
        (async () => await loadData())();
    }, []);
    const loadData = () => {
        dispatch(getDepartments())
    }
    const onSelected = (element: any) => {
    }
    const onProfile = () => {
      setShowProfile(true)
    }

    const onAccount = () => {
        dispatch(setShowModal({showModal: true}));
        // setModalAccountShow(true);
    }
    const getFullName = () => {
        let fullName = '';
      if (session) {
          fullName = session?.name?.substring(0,1) + session?.last_name?.substring(0,1);
      }
      return fullName.toUpperCase();
    }
    const logOut = () => {
        dispatch(onLogout());
        return navigate(`/`);
    }
    const onClient = () => {
        dispatch(setShowRegister({showRegister: true}))
    }
    const onCloseRegister = () => {
        dispatch(setShowRegister({showRegister: false}))
    }
    const onHide = () => {
        dispatch(setShowModal({showModal: false}));
    }
    return <>
        <header className="navbar-light navbar-sticky">
               <nav className="navbar navbar-expand-xl z-index-9">
                <div className="container">
                    <a className="navbar-brand" href="/">
                        <img className="light-mode-item navbar-brand-item" src={logo} alt="logo" />
                    </a>
                    {/*Select departments*/}
                    <div className="navbar-collapse collapse">
                        <div className={'w-100'}>

                        </div>

                    </div>

                    <div className="navbar-collapse collapse" >
                        <div className="col-12">
                            <div className="nav my-3 my-xl-0 px-4 flex-nowrap align-items-center">
                                <div className="nav-item w-100">
                                </div>
                            </div>
                        </div>
                    </div>

                    <ul className="nav flex-row align-items-end">
                        {/*icons calendar*/}
                        {status == 'authenticated' && <li className="nav-item ms-0 ms-sm-2 ">
                            <a className="btn btn-light btn-round mb-0" href="/schedule">
                                <i className="bi bi-calendar fa-fw"></i>
                            </a>
                        </li>
                        }


                        {/*icon notifications*/}
                        {status == 'authenticated' &&
                            <li className="nav-item ms-0 ms-sm-2 ">
                                <a className="btn btn-light btn-round mb-0" href="/notification">
                                    <i className="bi bi-bell fa-fw"></i>
                                </a>
                            </li>
                        // <li className="nav-item ms-2 ms-sm-3 dropdown">
                        //     <a className="btn btn-light btn-round mb-0" href="#" role="button" data-bs-toggle="dropdown"
                        //        aria-expanded="false" data-bs-auto-close="outside">
                        //         <i className="bi bi-bell fa-fw"></i>
                        //     </a>
                        //     <span className="notif-badge animation-blink"></span>
                        //     <div
                        //         className="dropdown-menu dropdown-animation dropdown-menu-end dropdown-menu-size-md p-0 shadow-lg border-0">
                        //         <div className="card bg-transparent">
                        //             <ShowNotification />
                        //             <div className="card-footer bg-transparent border-0 py-3 text-center position-relative">
                        //                 <a href="/notification" className="stretched-link">ver</a>
                        //             </div>
                        //         </div>
                        //     </div>
                        // </li>
                        }

                        {/*profile icon*/}
                        {session ?
                            <li className="nav-item ms-3 dropdown">
                                <a className="avatar avatar-sm p-0 " onClick={() => onProfile()} href="#" id="profileDropdown" role="button"
                                   data-bs-auto-close="outside" data-bs-display="static" data-bs-toggle="dropdown"
                                   aria-expanded="true">
                                    <div
                                        className="avatar-img rounded-circle border border-3 border-info bg-dark">
                                                        <span
                                                            className="text-white position-absolute top-50 start-50 translate-middle fw-bold">{getFullName()}</span>
                                    </div>
                                </a>
                                {/*${isBoxVisible ? "" : "hidden"*/}
                                <ul className={`dropdown-menu dropdown-animation dropdown-menu-end shadow pt-3 ${showProfile ? "show" : ""}`}
                                    aria-labelledby="profileDropdown">
                                    <li className="px-3 mb-3">
                                        <div className="d-flex align-items-center">
                                            <div className="avatar me-2">
                                                <div className="avatar align-middle">
                                                    <div
                                                        className="avatar-img rounded-circle border border-3 border-info bg-dark">
                                                        <span
                                                            className="text-white position-absolute top-50 start-50 translate-middle fw-bold">{getFullName()}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <a className="h6" href="#">{session.name}</a>
                                                <p className="small m-0">{session.last_name}</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li><a className="dropdown-item" href="/profile"><i className="bi bi-person fa-fw me-2">

                                    </i>Mi Perfil</a></li>
                                    <li><a className="dropdown-item" href="/schedule">
                                        <i className="bi bi-calendar fa-fw me-2"></i> Mis citas </a></li>
                                    {/*<li><a className="dropdown-item" href="#">*/}
                                    {/*    <i className="bi bi-info-circle fa-fw me-2"></i>Ayuda</a>*/}
                                    {/*</li>*/}
                                    {session?.is_support == 1 && <li>
                                        <button className="dropdown-item" onClick={() => onClient()}>
                                            <i className="bi bi-calendar fa-fw me-2"></i> Registrar cliente</button>
                                    </li>}

                                    <li><a className="dropdown-item" href="/address">
                                        <i className="bi bi-calendar fa-fw me-2"></i> Mis direcciones</a></li>
                                    <li><a className="dropdown-item" href="/notification">
                                        <i className="bi bi-bell fa-fw me-2"></i>Notificaciones</a>
                                    </li>
                                    <li>
                                        <button className="dropdown-item bg-danger-soft-hover" onClick={() => logOut()}>
                                            <i className="bi bi-power fa-fw me-2"></i>Cerrar Sesion</button>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                </ul>
                            </li>
                            :
                            <div className="navbar-nav  d-lg-inline-block">
                                <button className="btn btn-success-soft mb-0" onClick={() => onAccount()}>
                                    <i className="fas fa-sign-in-alt me-2"></i>Inicie Sesión
                                </button>
                            </div>
                        }

                    </ul>
                </div>
            </nav>
        </header>
        <ModalAccount
            show={showModal}
            onHide={() => onHide()}
        />
        <ModalRegister
            show={showRegister}
            onHide={() => onCloseRegister()}
        />
    </>
}
